import type { ItineraryDay } from "@/api/tour";
import Itinerary from "@/components/Itinerary";

interface ItinerarySectionProps {
  list?: ItineraryDay[];
}

export default function ItinerarySection({ list }: ItinerarySectionProps) {
  return <Itinerary list={list} compact />;
}
